import { titleSizes } from '@/ui/text/title/Title'
import { z } from 'zod'
import { loyaltyCardTagSizeSchema } from './LoyaltyCardTag'
import { LoyaltyColorSchema } from './LoyaltyColor'
import { LoyaltyIconSchema } from './LoyaltyIcon'
import { LoyaltyBackgroundSchema } from './LoyaltyTint'

export const LoyaltyBaseCardSchema = z.object({
  tint: LoyaltyBackgroundSchema,
  tag: z
    .object({
      title: z.string().optional(),
      color: LoyaltyColorSchema.optional(),
      size: loyaltyCardTagSizeSchema.optional(),
      programName: z.boolean().optional(),
    })
    .optional(),
  title: z
    .object({
      light: z
        .object({
          color: LoyaltyColorSchema.optional(),
          text: z.string().optional(),
          size: z.enum(titleSizes).optional(),
          noUppercase: z.boolean().optional(),
        })
        .optional(),
      big: z
        .object({
          color: LoyaltyColorSchema.optional(),
          text: z.string().optional(),
          size: z.enum(titleSizes).optional(),
          noUppercase: z.boolean().optional(),
        })
        .optional(),
      watermark: z
        .object({
          text: z.string().optional(),
          size: z.string().optional(),
        })
        .optional(),
      color: LoyaltyColorSchema.optional(),
    })
    .optional(),
  image: z.string().optional(),
  gradient: z.string().optional(),
  link: z
    .object({
      title: z.string(),
      url: z.string().optional(),
    })
    .optional(),
})

export const AdCardDataSchema = LoyaltyBaseCardSchema.extend({
  content: z
    .object({
      title: z.object({
        icon: LoyaltyIconSchema,
        text: z.string(),
      }),
      description: z.string(),
    })
    .optional(),
})
